import { TAdvantagesCardData } from '../containers/catalogue/advantages/types';

export const advantagesImgSizes = {
	tiny: {
		width: 576,
		height: 400,
	},
	small: {
		width: 600,
		height: 414,
	},
	medium: {
		width: 600,
		height: 414,
	},
	large: {
		width: 742,
		height: 414,
	},
};

export const AdvantagesCardsData: TAdvantagesCardData[] = [
	{
		header: 'Гарантируем качество услуг',
		isHeaderShort: true,
		photoUrl: '/3fgNFEdkk0Sr2RgGrACUCw/services-platform-landing-guarantee-quality',
		listItems: [
			'Даём гарантию на&nbsp;работы*.',
			'Исправляем недостатки в&nbsp;выполненных работах.',
			'Обучаем исполнителей правилам работы с&nbsp;нашими заказами и собираем ваши отзывы для улучшения качества сервиса.',
		],
		remark: true,
	},
	{
		header: 'Предлагаем фиксированные цены на&nbsp;услуги',
		isHeaderShort: false,
		photoUrl: '/cOpIqhYYCEe3AqVXppMzbg/services-platform-landing-offer-fixed-prices',
		listItems: [
			'Гарантируем доступные цены на&nbsp;работы.',
			'Фиксируем цену каждой услуги и&nbsp;не&nbsp;меняем её&nbsp;в&nbsp;процессе выполнения заказа.',
			'Мастер согласует с&nbsp;вами изменение общей стоимости заказа, если в&nbsp;процессе его выполнения изменится набор услуг.',
		],
		remark: false,
	},
	{
		header: 'Бережём ваше время и&nbsp;силы',
		isHeaderShort: true,
		photoUrl: '/IVB4d2X3vk-OM960UcRyiQ/services-platform-landing-save-your-time',
		listItems: [
			'Предлагаем комплексную покупку товаров и&nbsp;услуг для вашего проекта в&nbsp;одном месте.',
			'Берём на&nbsp;себя отбор и&nbsp;проверку партнёров, выполняющих услуги.',
			'Контролируем статус выполнения вашего заказа.',
		],
		remark: false,
	},
];
